class SiteAlert extends HTMLElement {

  constructor() {
    super();
    this.alertMessage = this.querySelector('.js-alert-message');
    this.close = this.querySelectorAll('.js-alert-close');
    this.listeners();
    this.timeout = '';
    this.useTimeout = this.getAttribute('data-use-timeout') || false;
  }

  listeners() {
    document.addEventListener('alert:show', (e) => {
      this.showAlert(e);
    });

    document.addEventListener('alert:clear', () => {
      this.clearAlert();
    });

    if (this.close) { 
      this.close.forEach((close) => {
        close.addEventListener('click', () => {
          this.clearAlert();
        })
      });
    }

    this.addEventListener('mouseenter', () => {
      if (this.timeout) {clearTimeout(this.timeout)}
    });

    this.addEventListener('mouseleave', () => {
      this.setHideTimeout();
    });
  }

  setHideTimeout() {
    if (!this.useTimeout) return

    this.timeout = setTimeout(() => {
      this.clearAlert();
    }, 10000);
  }

  showAlert(e) {
    if (this.timeout) {clearTimeout(this.timeout)}

    if (this.alertMessage) {
      this.classList.remove('site-alert--hidden', 'site-alert--error', 'site-alert--success');

      if (e.detail.data.status == 'Error') {
        this.classList.add('site-alert--error');
      } else {
        this.classList.add('site-alert--success');
      }

      this.alertMessage.innerHTML = e.detail.data.message;
    }

    this.setHideTimeout();
  }

  clearAlert() {
    if (this.timeout) {clearTimeout(this.timeout)}
    if (this.alertMessage) {
      this.alertMessage.innerHTML = ''
    }
    this.className = 'site-alert site-alert--hidden';
  }
}

customElements.define('site-alert', SiteAlert);
